import { type TripStatus } from "@tc/shared";

/** TripStatus → the `status.*` i18n key (the catalogue already carries every label). */
export const STATUS_KEY: Record<TripStatus, string> = {
  Enquiry: "status.enquiry",
  ProposalSent: "status.proposalSent",
  Accepted: "status.accepted",
  Completed: "status.completed",
  Cancelled: "status.cancelled",
  Postponed: "status.postponed",
  Expired: "status.expired",
};

/**
 * Urgency tone for a date relative to today — drives the colour of departure countdowns on the
 * dashboard and trip detail. Mirrors the prototype's `deadlineTone`: past = danger, within three
 * days = warning, otherwise muted. Proposal deadlines (acceptance/deposit/flight) are a Module-3
 * concept; until then the only date we count down to is a trip's travel start.
 */
export type DateTone = "overdue" | "soon" | "ok";

export function dateTone(iso: string | null | undefined, now: Date = new Date()): DateTone {
  if (!iso) return "ok";
  const startOfDay = (d: Date) => new Date(d).setHours(0, 0, 0, 0);
  const days = Math.round((startOfDay(new Date(iso)) - startOfDay(now)) / 86_400_000);
  if (days < 0) return "overdue";
  if (days <= 3) return "soon";
  return "ok";
}

/** Tone → text/background colour tokens (no raw hex — tokens only). */
export const TONE_COLOR: Record<DateTone, string> = {
  overdue: "var(--danger)",
  soon: "var(--warning)",
  ok: "var(--text-muted)",
};

export const TONE_BG: Record<DateTone, string> = {
  overdue: "var(--danger-soft)",
  soon: "var(--warning-soft)",
  ok: "var(--surface-3)",
};
